module.exports = __webpack_public_path__ + "static/media/foodBag2.d46aad59.jpg";